import { IConfigsType } from '../../types'

const dhBenchmarkingProductMix: IConfigsType = {
  'mwb-benchmarking': {
    '/:brand/benchmarking_metrics': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'mwb/benchmarking_metrics',
        height: '1400px',
      },
    },
    '/:brand/benchmarking_product_mix': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'mwb/benchmarking_product_mix',
        height: '1400px',
      },
    },
    '/:brand/benchmarking_marketing_campaign': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'mwb/benchmarking_marketing_campaign',
        height: '1400px',
      },
    },
  },
}

export default dhBenchmarkingProductMix
